import React, { useEffect, useState } from "react";
import { TelegramLogo } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [tg, setTg] = useState("DutchMoney420");
  const [brand, setBrand] = useState("DutchMoney Shop");

  useEffect(() => {
    api.get("/meta/config").then(({ data }) => { setTg(data.telegram_handle); setBrand(data.brand); }).catch(()=>{});
  }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter/subscribe", { email });
      toast.success("Subscribed. Check your inbox.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Try again.");
    }
  };

  return (
    <footer className="relative bg-black text-bone mt-32 border-t border-signal/40 grain overflow-hidden" data-testid="site-footer">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="overline opacity-60 mb-4">// Newsletter</p>
          <h3 className="font-display font-black text-4xl md:text-5xl leading-none tracking-tighter mb-6">
            Get the drop<br/>before it lands.
          </h3>
          <form onSubmit={subscribe} className="flex flex-col sm:flex-row gap-3 max-w-lg" data-testid="footer-newsletter-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="flex-1 bg-transparent border border-white/30 px-4 py-3 text-bone placeholder:text-white/40 focus:outline-none focus:border-signal"
              data-testid="footer-newsletter-input" />
            <button type="submit" className="btn-signal" data-testid="footer-newsletter-submit">Subscribe →</button>
          </form>
        </div>

        <div className="md:col-span-3">
          <p className="overline opacity-60 mb-4">// Support</p>
          <a href={`https://t.me/${tg}`} target="_blank" rel="noreferrer"
             className="flex items-center gap-3 text-telegram hover:underline"
             data-testid="footer-telegram-link">
            <TelegramLogo size={24} weight="fill" />
            <span className="font-mono">@{tg}</span>
          </a>
          <p className="text-sm opacity-60 mt-3 leading-relaxed">
            Chat with us on Telegram for order help, custom work, and crypto payments.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline opacity-60 mb-4">// Shop</p>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-signal">All items</a></li>
            <li><a href="/shop?category=handmade" className="hover:text-signal">Handmade</a></li>
            <li><a href="/shop?category=digital" className="hover:text-signal">Digital</a></li>
          </ul>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap justify-between gap-4 text-xs font-mono opacity-50">
          <span>© {new Date().getFullYear()} {brand}</span>
          <span>Card + Crypto · Mail · Local Delivery</span>
        </div>
      </div>
    </footer>
  );
}
